var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('area-chart',{attrs:{"id":"area","data":_vm.areaChart.data,"colors":_vm.areaChart.colors,"xkey":_vm.areaChart.xkey,"ykeys":_vm.areaChart.ykeys,"grid":_vm.areaChart.grid,"resize":_vm.areaChart.resize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }